import React, { useState } from "react";
import Box from "@mui/material/Box";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { useSelector } from "react-redux";
import {
  setSelectedComponents,
  setSelectedFeatures,
} from "../../../../../features/templateSlice";
import store from "../../../../../store";

interface TemplateFilterProps {
  designTemplatesData: any;
  clearSelectedTemplate: any;
}

export default function TemplatesFilter({
  designTemplatesData,
  clearSelectedTemplate,
}: TemplateFilterProps) {
  const [searchComponent, setSearchComponent] = useState("");
  const [searchFeature, setSearchFeature] = useState("");
  const { selectedFeatures, selectedComponents } = useSelector(
    (state: any) => state.template
  );

  const filterConfig = [
    {
      key: "features",
      label: "Select labels",
      searchTerm: searchFeature,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchFeature(e.target.value),
      selectedOption: selectedFeatures,
      filterName: "labels",
      data: designTemplatesData,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedFeatures(updatedSelection)),
      count: selectedFeatures && selectedFeatures.length,
      colorSelected:
        selectedFeatures !== null && selectedFeatures.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "component",
      label: "Select component",
      searchTerm: searchComponent,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchComponent(e.target.value),
      selectedOption: selectedComponents,
      filterName: "component",
      data: designTemplatesData,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedComponents(updatedSelection)),
      count: selectedComponents && selectedComponents.length,
      colorSelected:
        selectedComponents !== null && selectedComponents.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    clearSelectedTemplate(null);
    store.dispatch(setSelectedComponents(null));
    store.dispatch(setSelectedFeatures(null));
  };

  return (
    <Box data-tracker="147">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
